var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempAvaliacaoWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802,
    height: 450,
    viewBox: "0 0 802 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_118_2915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 746,
    height: 394,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 139,
    width: 248,
    height: 67,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 227,
    width: 530,
    height: 57,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 139,
    width: 248,
    height: 20.8488,
    rx: 10.4244,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.854 146.233L423.734 150.178L428.614 146.233L430.112 147.448L423.734 152.616L417.355 147.448L418.854 146.233Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 185,
    width: 248,
    height: 20.8488,
    rx: 10.4244,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.854 192.233L423.734 196.178L428.614 192.233L430.112 193.448L423.734 198.616L417.355 193.448L418.854 192.233Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.112 146.091C148.112 145.419 147.538 144.868 146.837 144.868H136.631C135.93 144.868 135.355 145.419 135.355 146.091V153.431C135.355 154.104 135.93 154.654 136.631 154.654H146.837C147.538 154.654 148.112 154.104 148.112 153.431V146.091ZM146.837 146.091L141.734 149.15L136.631 146.091H146.837ZM146.837 153.431H136.631V147.315L141.734 150.373L146.837 147.315V153.431Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.379 106.259L357.32 108.765L356.274 104.042L359.757 100.864L355.171 100.454L353.379 96L351.586 100.454L347 100.864L350.483 104.042L349.437 108.765L353.379 106.259Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.135 106.259L378.077 108.765L377.031 104.042L380.514 100.864L375.928 100.454L374.135 96L372.343 100.454L367.757 100.864L371.239 104.042L370.193 108.765L374.135 106.259Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.892 106.259L398.834 108.765L397.788 104.042L401.271 100.864L396.685 100.454L394.892 96L393.1 100.454L388.514 100.864L391.996 104.042L390.95 108.765L394.892 106.259Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.649 106.259L419.591 108.765L418.545 104.042L422.028 100.864L417.441 100.454L415.649 96L413.857 100.454L409.271 100.864L412.753 104.042L411.707 108.765L415.649 106.259Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.406 106.259L440.348 108.765L439.302 104.042L442.784 100.864L438.198 100.454L436.406 96L434.613 100.454L430.027 100.864L433.51 104.042L432.464 108.765L436.406 106.259Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_118_2915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 318,
    width: 166,
    height: 34.0389,
    rx: 17.0194,
    fill: "#CCCCCC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_118_2915",
    x: 0,
    y: 0,
    width: 802,
    height: 450,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_118_2915"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2915"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2915",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_118_2915",
    x: 125,
    y: 318,
    width: 168,
    height: 49.0388,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_118_2915"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2915"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2915",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempAvaliacaoWeb);
export default __webpack_public_path__ + "static/media/TempAvaliacaoWeb.62f17d16792f542bcbc7bd35a34b8a26.svg";
export { ForwardRef as ReactComponent };